import { LOCALES } from "./locales";

export const messages = {
  [LOCALES.ENGLISH]: {
    price: "Price",
    close: "Close",
    submit: "Submit",
    confirm: "Confirm",
    orderDate: "Order Date",
    confirmation: "Confirmation",
    item: "Item",
    quantity: "Quantity",
    total: "Total",
    shareOrder: "Share order to agent with",
    MASAKADO: "MASAKADO",
    MASAKADOx1: "MASAKADO x1",
    MASAKADOSetx1: "MASAKADOSet x1",
    oneSetTwoBottle: "1 Set 2 Bottle",
    paiGow: "Pai Gow",
    oneSetPaiGow: "1 Set Pai Gow",
    zodiacPlayingCards: " Zodiac Playing Cards",
    aDeckOfZodiacPlayingCards: "A Deck Of Zodiac Poker Cards",
    luckySnakeNewYear: "Lucky Snake New Year",
    bUHOTOROZORROMERLOT750MLx1: "BUHO / TORO / ZORRO MERLOT 750ML x1",
    bUHOTOROZORROMERLOT750MLx2: "BUHO / TORO / ZORRO MERLOT 750ML x2",
    rAMAHRAMAHx2: "RAMAH-RAMAH x2",
    rAMAHRAMAHx3: "RAMAH-RAMAH x3",
    kexiRockSugarBirdsORHongJing70MLx6:
      "Kexi Rock Sugar Bird's Nest/Kexi Hong Jing 70ML x6",
    koreanGinsengCandyx1: "Korean Ginseng Candy x1",
    premiumCordycepsFlower60gx1: "Premium Cordyceps Flower 60g x1",
    braisedOrClearSoupAbalone5To6pieces45gx1:
      "Braised/Clear Soup Abalone 5-6 pieces 45g x1",
    travelboxx1: "Travel Box x1",
    福蛇送喜: "Lucky snake brings happiness",
    hENNESSYVSOP70CLx1: "HENNESSY VSOP 70CL x1",
    hENNESSYVSOP70CLx2: "HENNESSY VSOP 70CL x2",
    HENNESSYXOODYSSEYVAP202370CLx1: "HENNESSY XO ODYSSEY VAP 2023 70CL X1",
    XR212024DRAGON75CLx2: "XR21 2024 DRAGON 75CL X2",
    XR2175CLx1: "XR21 75CL x1",
    HARDYNOCESDOR70CLx1: "HARDY NOCES D'OR 70CL X1",
    TWINFISHORANGESLICESCHEWYCANDY150GMx2:
      "TWINFISH ORANGE SLICES CHEWY CANDY 150GM X2",
    红烧or清汤鲍鱼85克5米x1: "Braised/Clear Soup Abalone 85g (5m) x 1",
    可喜博克牌x1: "Kexi  Poker Card x1",
    可喜冰糖燕窝or可喜鸡精70MLx3:
      "Kexi Rock Sugar Bird's Nest/Kexi Chicken Essence 70ML x3",
    可喜冰糖燕窝or可喜鸡精70MLx6:
      "Kexi Rock Sugar Bird's Nest/Kexi Chicken Essence 70ML x6",
    可喜冰糖燕窝or可喜鸡精70MLx12:
      "Kexi Rock Sugar Bird's Nest/Kexi Chicken Essence 70ML x12",
    可喜冰糖燕窝70MLx6: "Kexi Rock Sugar Bird's Nest 70ML x6",
    可喜冰糖燕窝70MLx12: "Kexi Rock Sugar Bird's Nest 70ML x12",
    可喜鸡精70MLx6: "Kexi Chicken Essence 70ML x6",
    可喜鸡精70MLx12: "Kexi Chicken Essence 70ML x12",
    AIKCHEONG可喜联名CHOCOLATE4FLAVOURx2SACHETS:
      "AIK CHEONG collaboration Kexi CHOCOLATE 4 FLAVOUR x2 SACHETS",
    燕窝BUY1FREE1: "Bird's Nest BUY 1 FREE 1",
    买燕窝送鸡精或燕窝:
      "Buy bird's nest and get chicken essence or bird's nest for free",
    财神临门礼篮: "God of Fortune Gift Basket",
    黑松露or干贝or红烧or清汤鲍鱼85克5头x1:
      "Black Truffle/Scallop/Braised/Clear Soup Abalone 85g (5 heads) x1",
    红烧or清汤鲍鱼45克5头to6头x1: "Braised/Clear Soup Abalone 45g 5-6 heads X1",
    红烧or清汤鲍鱼85克5头to6头x1: "Braised/Clear Soup Abalone 85g 5-6 heads X1",
    红烧or清汤鲍鱼85克5头to6头x2: "Braised/Clear Soup Abalone 85g 5-6 heads x2",
    红烧or清汤鲍鱼85克5头to10头x1:
      "Braised/Clear Soup Abalone 85g 5-10 heads X1",
    黑松露or干贝鲍鱼85克5头to6头x1:
      "Black Truffle/Scallop Abalone 85g 5-6 heads x1",
    黑松露or干贝鲍鱼85克5头to6头x2:
      "Black Truffle/Scallop Abalone 85g 5-6 heads x2",
    精美可喜独创设计盒x1: "Exquisite Kexi original design box x1",
    财神贺岁礼篮: "God of Fortune New Year Gift Basket",
    冰糖雪耳燕窝70mlx2: "Rock sugar snow fungus bird's nest 70ml x2",
    冰糖雪耳燕窝150mlx3: "Rock sugar snow fungus bird's nest 150ml x3",
    冰糖雪耳燕窝150mlx8: "Rock sugar snow fungus bird's nest 150ml x8",
    花艺葫芦限量款Limited40setonly:
      "Floral gourd limited edition *Limited 40 set only",
    MartellVSOPgiftse7clx1: "Martell VSOP gift set + 7cl x1",
    MartellVSOPgiftsetcomeswithPremiumGlassNVSOPminiature3clx1:
      "Martell VSOP gift set comes with Premium Glass & VSOP miniature 3cl) X 1",
    MARTELLVSOP350ML: "MARTELL VSOP 350 ML",
    MARTELLVSOP350MLx2: "MARTELL VSOP 350 ML x2 bottle",
    MARTELLCORDONBLUEWUJIANANLIMITEDEDITIONFY2570CLX1:
      "MARTELL CORDON BLUE WU JIAN AN LIMITED EDITION FY25 70CL X1",
    MARTELLCORDONBLEUWUJIANANCNYGIFTSETDECANTERFY2570CLx1:
      "MARTELL CORDON BLEU WU JIAN AN CNY GIFTSET (DECANTER) FY25 70CL X1",
    MARTELLNOLIMITEDEDITIONFY2570CLx1:
      " MARTELL NO LIMITED EDITION FY25 70CL X1",
    ChivasRegal12CNYGiftset70clcomeswithChivas18Miniaturex1:
      "Chivas Regal 12 CNY Giftset 70cl (comes with Chivas 18 Miniature) x 1",
    GLENRONACH12Y70CLX1: "GLENRONACH 12Y 70CL X1",
    顶级茶饼大红袍x1: "Premium Tea Cake Dahongpao x1",
    母树老山参刈x1: "Mother tree old mountain ginseng cutting x1",
    双金花燕饼x1: "Double Golden Flower Bird's Nest Cake x1",
    金丝燕窝片3片x1: "3 pieces of Golden Bird's Nest slices x1",
    鳕鱼花胶x1: "Cod Fish Maw x1",
    山珍海味鲨鱼骨100gx1: "Shark bone 100g x1",
    山珍海味鲨鱼骨100gx2: "Shark bone 100g x2",
    野生虫草花60gx1: "Wild Cordyceps Flower 60g x1",
    幸运招财猫x1: "Lucky Cat Doll x1",
    葫芦瓦礼篮x1: "Huluwa Gift Basketx1",
    手艺花艺x8: "Handmade Flower Arrangement x8",
    MOLLEorOLDFIELDorREDLEAForTOBISSorMERLOTREDWINE375MLx1:
      "MOLLE / OLD FIELD / REDLEAF / TOBISS / MERLOT RED WINE 375ML X1",
    万事如意: "May all your wishes come true",
    野生茶花冬菇150克x1: "150g Wild Camellia Mushroom x1",
    韩国人参糖x1: "Korean Ginseng Candy X1",
    野生发菜x1: "Wild hair algae X1",
    野生发菜30克x1: "30g wild hair algae X1",
    野生发菜30克x2: "30g wild hair algae X2",
    HOOHEE糖果礼盒x1: "HOOHEE candy gift box X1",
    HOOHEE糖果礼盒x2: "HOOHEE candy gift box X2",
    可喜春节礼篮x1: "Kexi Spring Festival gift basket X1",
    可喜春节礼篮x2: "Kexi Spring Festival gift basket X2",
    年年有余: "More than enough every year",
    母树大红袍9包装x1: "Mother tree Da Hong Pao 9 packs X1",
    母树大红袍9包装x2: "Mother tree Da Hong Pao 9 packs X2",
    北冬蟲夏草or灵芝or人参峰王液体10支装100MLx1:
      "Cordyceps sinensis/Ganoderma lucidum/Ginseng Peak King Liquid 10 sticks 100ML X1",
    北冬蟲夏草or灵芝or人参峰王液体10支装100MLx2:
      "Cordyceps sinensis/Ganoderma lucidum/Ginseng Peak King Liquid 10 sticks 100ML X2",
    顶级虫草花60克x1: "Premium Cordyceps Flower 60g x1",
    顶级虫草花60克x2: "Premium Cordyceps Flower 60g x2",
    纯正银雪耳150克x1: "Pure Silver Fungus 150g X1",
    新年摆饰品x3: "New Year decorations x3",
    新年摆饰品x5: "New Year decorations x5",
    新年摆饰品x6: "New Year decorations X6",
    新年摆饰品x8: "New Year decorations x8",
    纳福亨通: "Good fortune and prosperity",
    生意兴隆: "Prosperous Business",
    福泰安康1个价钱2个礼篮: "Fortune and Health (1 price for 2 gift baskets)",
    迎春纳福: "Welcoming Spring and Blessings",
    财源亨通: "Smooth Financial Success",
    八仙报喜: "Eight Immortals Bringing Good News",
    五福临门: "Five Blessings Arrive at Your Doorstep",
    金玉满堂: "Gold and Jade Abound",
    喜气洋洋: "Joyful Atmosphere",
    大吉大利: "Great Prosperity and Luck",
    喜气盈门: "Joy Fills the Door",
    心想事成: "Dreams Come True",
    八方来财: "Wealth Comes from All Directions",
    千事吉祥: "A Thousand Auspicious Events",
    百事亨通Limited400setonly: "All Things Go Well *Limited 400 Sets Only*",
    合家平安: "Family Peace",
    福寿双全: "Fortune and Longevity Together",
    六六大顺: "Double Six for Smoothness",
    七星高照: "Seven Stars Shine Bright",
    多福多寿: "Many Blessings and Long Life",
    得心应手: "Success Comes Naturally",
    四季平安: "Peace All Year Round",
    花开富贵: "Blooming Flowers and Prosperity",
    福气东来LIMITED200SET: "Fortune Comes East *LIMITED 200 SET*",
    福禄寿禧LIMITED200SET:
      "Fortune, Prosperity, Longevity, and Happiness *LIMITED 200 SET*",
    飞黄腾达LIMITED200SET: "Soaring Success *LIMITED 200 SET*",
    三羊开泰: "Three Goats Bring Auspiciousness",
    祥瑞新年: "A Propitious New Year",
    马到成功: "Instant Success",
    旗开得胜: "Victory from the Start",
    蛇来运转: "Snake Brings Good Fortune",
    喜蛇临门: "Joyful Snake Arrives",
    大西洋冰岛鱼胶x1: "Atlantic Iceland Fish Maw x1",
    老班章普洱茶饼x1: "Old Banzhang Pu'er Tea Cake x1",
    纯天然黑木耳50克x1: "Pure Natural Black Fungus 50g x1",
    纯天然黑木耳50克x2: "Pure Natural Black Fungus 50g x2",
    野米花胶or小米花胶or大西洋冰岛鱼就胶240克x1:
      "Wild Rice Fish Maw/Small Rice Fish Maw/Atlantic Iceland Fish Maw 240g x1",
    野米花胶or小米花胶or大西洋冰岛鱼就胶or佛跳墙240克x1:
      "Wild Rice Fish Maw/Small Rice Fish Maw/Atlantic Iceland Fish Maw/Buddha Jumps Over the Wall 240g x1",
    JOHNNIEWALKERBLACKLABELSHERRYCASK700MLx1:
      "JOHNNIE WALKER BLACK LABEL SHERRY CASK 700ML X1",
    传统工艺紫茶壶x1: "Traditional Craft Purple Teapot x1",
    可喜春节摆饰品: "Kexi Spring Festival Decorations",
    可喜春节摆饰品x1: "Kexi Spring Festival Decorations x1",
    可喜春节摆饰品x3: "Kexi Spring Festival Decorations x3",
    可喜春节摆饰品x5: "Kexi Spring Festival Decorations x5",
    可喜春节摆饰品x10: "Kexi Spring Festival Decorations x10",
    可喜春节摆饰品x12: "Kexi Spring Festival Decorations x12",
    可喜礼篮x1: "Kexi Gift Basket x1",
    林下山参x1: "Forest ginseng x1 piece",
    花燕2片装x1: "Pack of 2 pieces of Huayan slices x1",
    花燕片2片装x1: "Pack of 2 pieces of Huayan slices x1",
    花燕片3片装x1: "Pack of 3 pieces of Huayan slices x1",
    花燕片3片装x2: "Pack of 3 pieces of Huayan slices x2",
    易武云南普洱大圆茶饼x1: "Yiwu Yunnan Pu'er Big Round Tea Cake x1",
    易武云南普洱大圆茶饼加木盒x1:
      "Yiwu Yunnan Pu'er Big Round Tea Cake with Wooden Box x1",
    红参片or鱼胶or人参片or鱼翅礼盒x1:
      "Red Ginseng Slices/Fish Maw/Ginseng Slices/Shark Fin Gift Box x1",
    红参片or鱼胶or人参片or鱼翅礼盒x2:
      "Red Ginseng Slices/Fish Maw/Ginseng Slices/Shark Fin Gift Box x2",
    红参片or鱼胶or人参片or鱼翅礼盒x3:
      "Red Ginseng Slices/Fish Maw/Ginseng Slices/Shark Fin Gift Box x3",
    纽西兰鳕鱼胶x1: "New Zealand Cod Fish Maw x1",
    可喜人参鸡精70mlx6: "Kexi Ginseng Chicken Essence 70ml x6",
    燕窝饮料150mlx1: "Bird's Nest Drink 150ml x1",
    燕窝饮料150mlx2: "Bird's Nest Drink 150ml x2",
    燕窝饮料150mlx4: "Bird's Nest Drink 150ml x4",
    燕窝饮料250mlx1: "Bird's Nest Drink 250ml x1",
    燕窝饮料250mlx2: "Bird's Nest Drink 250ml x2",
    燕窝饮料250mlx4: "Bird's Nest Drink 250ml x4",
    贵州茅台王子白酒53巴仙500MLx1: "Guizhou Moutai Prince Liquor 53% 500ML x1",
    老山参礼盒x1: "Old Ginseng Gift Box x1",
    可喜礼蓝x1: "Kexi gift basket x1",
    可喜摇头舞狮摆件x1: "Kexi shaking head lion dance ornament x1",
    日本干贝礼盒SA16粒: "Japanese Scallop Gift Box (SA 16 pcs)",
    金鼠摆件x2: "Golden Rat Figurine x2",
    冰糖燕窝150MLx3: "Rock Sugar Bird's Nest 150ML x3",
    冰糖燕窝250MLx1: "Rock Sugar Bird's Nest 250ML x1",
    精美可喜礼盒x1: "Exquisite Kexi gift box x1",
    精美小铁罐x1: "Exquisite Small Tin x1",
    紫茶壶x1: "Purple Teapot x1",
    清汤一头鲍鱼x2: "Clear Soup Whole Abalone x2",
    燕窝黄燕盏120Gx1: "Bird's Nest Yellow Cup 120G x1",
    海参礼盒x1: "Sea Cucumber Gift Box x1",
    燕窝黄燕盏6片装: "Bird's Nest Yellow Cup 6 Slices Pack",
    燕窝黄燕盏6片装x1: "Bird's Nest Yellow Cup 6 Slices Pack x1",
    醒狮x1: "Awakened Lion x1",
    招财猫x1: "Fortune Cat x1",
    南非清汤鲍鱼一头鲍x1: "South African Clear Soup Whole Abalone x1",
    海参礼盒装x1: "Sea Cucumber Gift Box x1",
    红烧海参x1: "Braised Sea Cucumber x1",
    燕窝2片x1: "Bird's Nest 2 Slices x1",
    冰糖雪蛤240克x1: "Rock sugar snow clam 240g x 1",
    佛跳墙x1: "Buddha Jumps Over the Wall x1",
    可喜精美扇子礼盒: "Kexi exquisite fan gift box",
    精美可喜抽屉礼盒x1: "Exquisite Kexi drawer gift box x1",
    可喜红烧海参x1: "Kexi Braised Sea Cucumber x1",
    精美可喜3D礼盒x1: "Exquisite Kexi 3D gift box x1",
    可喜精美礼盒x1: "Kexi exquisite gift box x1",
    大红大紫: "Great Fortune",
    可喜药材鸡精70MLx6: "Kexi Herbal Essence 70ML x6",
    冰岛鱼胶x1: "Iceland Fish Maw x1",
    北夏草液体x1: "Northern Cordyceps Liquid x1",
    山珍海味x1: "Delicacies from Mountains and Seas x1",
    万事逐心: "Everything Goes Your Way",
    纯天然茶花菇x1: "Pure Natural Tea Tree Mushrooms x1",
    精品鱼胶x1: "Premium Fish Maw x1",
    大红袍x1: "Da Hong Pao x1",
    人参糖x1: "Ginseng Candy x1",
    干贝鲍鱼x1: "Dried Scallops and Abalone x1",
    百业兴旺: "Thriving Business",
    吉庆有余: "Abundance and Prosperity",
    OWLCITYx1: "OWL CITY x1 ",
    烧好肉碎: "Cooked Minced Meat",
    烧好肉碎500gx1L: "Cooked Minced Meat 500g x1",
    烧好鸡肉: "Cooked Chicken",
    烧好鸡肉500gx1: "Cooked Chicken 500g x1",
    烧好切片: "Cooked Slices",
    烧好切片500gx1: "Cooked Slices 500g x1",
    猪肉丝: "Pork Strips",
    猪肉丝300gx1: "Pork Strips 300g x1",
    鸡肉丝: "Chicken Strips",
    鸡肉丝300gx1: "Chicken Strips 300g x1",
    烧好金钱肉干: "Cooked Money Meat Jerky",
    烧好金钱肉干500gx1: "Cooked Money Meat Jerky 500g x1",
    小鲜炖10bottle50ml: "Xiao Xian Dun 10 bottles 50ml",
    小鲜炖50mlx10: "Xiao Xian Dun 50ml x10",
    鲜炖纯燕窝品质保证送礼佳品:
      "Fresh Stewed Pure Bird's Nest, Quality Guaranteed, Perfect Gift Choice",
    小鲜炖6bottle70ml: "Xiao Xian Dun 6 bottles 70ml",
    小鲜炖70mlx6: "Xiao Xian Dun 70ml x6",
    可喜烤肉干礼盒传递健康与美味的最佳选择:
      "Kexi Dried Meat Gift Box - The Best Choice for Health and Deliciousness!",
    普洱茶饼or精美茶壶茶香与烤肉的完美搭配:
      "Pu'er Tea Cake/Exquisite Teapot - The Perfect Pairing of Tea Aroma and Dried Meat!",
    肉干组合肉碎肉干or麻辣肉干or黑胡椒肉干or多种口味满足你的味蕾:
      "Dried Meat Combo: Minced Dried Meat, Spicy Dried Meat, Black Pepper Dried Meat - A Variety of Flavors to Satisfy Your Taste Buds!",
    本地猪肉and品质看得见and安全又放心:
      "- 100% Local Pork - Quality You Can See, Safe and Trustworthy!",
    不含任何防腐剂and吃得更健康: "- No Preservatives - Enjoy Healthier Eating!",
    传统工艺制作and每一片都蕴含匠心:
      "- Crafted with Traditional Techniques - Every Piece Embodies Artisanal Excellence!",
    切肉片肉干厚实鲜嫩一口满满幸福感:
      "Sliced Dried Meat: Thick, Tender, and Packed with Happiness in Every Bite!",
    可喜烤肉干礼盒: "Kexi Dried Meat Gift Box",
    清汤鲍鱼85克5头to6头x1: "Clear Soup Abalone 85g 5-6 heads x1",
    牌九x1: "Pai Gow x1",
    MOLLEorOLDFIELDorREDLEAForTOBISSMERLOTREDWINE375MLx1:
      "MOLLE/OLD FIELD/RED LEAF/TOBISS /MERLOT RED WINE 375ML x1",
  },

  [LOCALES.CHINESE]: {
    price: "价格",
    close: "关闭",
    submit: "提交",
    confirm: "确认",
    orderDate: "订单日期",
    confirmation: "确认",
    item: "商品",
    quantity: "数量",
    total: "总共",
    shareOrder: "将订单分享给代理",
    MASAKADO: "MASAKADO",
    MASAKADOx1: "MASAKADO x1",
    MASAKADOSetx1: "MASAKADOSet x1",
    oneSetTwoBottle: "1 Set 2 瓶",
    paiGow: "牌九",
    oneSetPaiGow: "1 Set 牌九",
    zodiacPlayingCards: "12生肖扑克牌",
    aDeckOfZodiacPlayingCards: "1 副生肖扑克牌",
    luckySnakeNewYear: "福蛇贺岁",
    bUHOTOROZORROMERLOT750MLx1: "BUHO / TORO / ZORRO MERLOT 750ML x1",
    bUHOTOROZORROMERLOT750MLx2: "BUHO / TORO / ZORRO MERLOT 750ML x2",
    rAMAHRAMAHx2: "RAMAH-RAMAH x2",
    rAMAHRAMAHx3: "RAMAH-RAMAH x3",
    kexiRockSugarBirdsORHongJing70MLx6: "可喜冰糖燕窝/可喜鸿精 70ML x6",
    koreanGinsengCandyx1: "韩国人参糖 x1",
    premiumCordycepsFlower60gx1: "顶级虫草花 60克 x1",
    braisedOrClearSoupAbalone5To6pieces45gx1: "红烧/清汤鲍鱼5-6头45克 x1",
    travelboxx1: "旅行箱 x1",
    福蛇送喜: "福蛇送喜",
    hENNESSYVSOP70CLx1: "HENNESSY VSOP 70CL x1",
    hENNESSYVSOP70CLx2: "HENNESSY VSOP 70CL x2",
    HENNESSYXOODYSSEYVAP202370CLx1: "HENNESSY XO ODYSSEY VAP 2023 70CL X1",
    HENNESSYXOJEANMICHELOTHONIEL70CLx1:
      "HENNESSY XO JEAN MICHEL OTHONIEL 70CL X1",
    XR212024DRAGON75CLx2: "XR21 2024 DRAGON 75CL X2",
    XR2175CLx1: "XR21 75CL x1",
    HARDYNOCESDOR70CLx1: "HARDY NOCES D'OR 70CL X1",
    TWINFISHORANGESLICESCHEWYCANDY150GMx2:
      "TWINFISH ORANGE SLICES CHEWY CANDY 150GM X2",
    红烧or清汤鲍鱼85克5米x1: "红烧/清汤鲍鱼85克(5米)x1",
    可喜博克牌x1: "可喜博克牌 x1",
    可喜冰糖燕窝70MLx6: "可喜冰糖燕窝 70ML x6",
    可喜冰糖燕窝70MLx12: "可喜冰糖燕窝 70ML x12",
    可喜鸡精70MLx6: "可喜鸡精 70ML x6",
    可喜鸡精70MLx12: "可喜鸡精 70ML x12",
    AIKCHEONG可喜联名CHOCOLATE4FLAVOURx2SACHETS:
      "AIK CHEONG 可喜联名 CHOCOLATE 4 FLAVOUR x2 SACHETS",
    燕窝BUY1FREE1: "燕窝 BUY 1 FREE 1",
    买燕窝送鸡精或燕窝: "买燕窝送鸡精或燕窝",
    财神临门礼篮: "财神临门礼篮",
    黑松露or干贝or红烧or清汤鲍鱼85克5头x1:
      "黑松露/干贝/红烧/清汤 鲍鱼85克(5头)x1",
    红烧or清汤鲍鱼45克5头to6头x1: "红烧/清汤鲍鱼 45克 5-6头 x1",
    红烧or清汤鲍鱼85克5头to6头x1: "红烧/清汤鲍鱼 85克 5-6头 x1",
    红烧or清汤鲍鱼85克5头to6头x2: "红烧/清汤鲍鱼 85克 5-6头 x2",
    红烧or清汤鲍鱼85克5头to10头x1: "红烧/清汤鲍鱼 85克 5-10头 x1",
    黑松露or干贝鲍鱼85克5头to6头x1: "黑松露/干贝鲍鱼 85克 5-6头 x1",
    黑松露or干贝鲍鱼85克5头to6头x2: "黑松露/干贝鲍鱼 85克 5-6头 x2",
    精美可喜独创设计盒x1: "精美可喜独创设计盒 x1",
    财神贺岁礼篮: "财神贺岁礼篮",
    冰糖雪耳燕窝70mlx2: "冰糖雪耳燕窝70ml x2",
    冰糖雪耳燕窝150mlx3: "冰糖雪耳燕窝150ml x3",
    冰糖雪耳燕窝150mlx8: "冰糖雪耳燕窝150ml x8",
    花艺葫芦限量款Limited40setonly: "花艺葫芦限量款*Limited 40 set only",
    MartellVSOPgiftse7clx1: "Martell VSOP gift set + 7cl x1",
    MartellVSOPgiftsetcomeswithPremiumGlassNVSOPminiature3clx1:
      "Martell VSOP gift set comes with Premium Glass & VSOP miniature 3cl) X 1",
    MARTELLVSOP350ML: "MARTELL VSOP 350 ML",
    MARTELLVSOP350MLx2: "MARTELL VSOP 350 ML x2 bottle",
    MARTELLCORDONBLUEWUJIANANLIMITEDEDITIONFY2570CLX1:
      "MARTELL CORDON BLUE WU JIAN AN LIMITED EDITION FY25 70CL X1",
    MARTELLCORDONBLEUWUJIANANCNYGIFTSETDECANTERFY2570CLx1:
      "MARTELL CORDON BLEU WU JIAN AN CNY GIFTSET (DECANTER) FY25 70CL X1",
    MARTELLNOLIMITEDEDITIONFY2570CLx1:
      " MARTELL NO LIMITED EDITION FY25 70CL X1",
    ChivasRegal12CNYGiftset70clcomeswithChivas18Miniaturex1:
      "Chivas Regal 12 CNY Giftset 70cl (comes with Chivas 18 Miniature) x 1",
    GLENRONACH12Y70CLX1: "GLENRONACH 12Y 70CL X1",
    顶级茶饼大红袍x1: "顶级茶饼大红袍x1",
    母树老山参刈x1: "母树老山参刈 x1",
    双金花燕饼x1: "双金花燕饼 x1",
    金丝燕窝片3片x1: "金丝燕窝片3片 x1",
    鳕鱼花胶x1: "鳕鱼花胶 x1",
    山珍海味鲨鱼骨100gx1: "山珍海味鲨鱼骨100g x1",
    山珍海味鲨鱼骨100gx2: "山珍海味鲨鱼骨100g x2",
    野生虫草花60gx1: "野生虫草花60g x1",
    幸运招财猫x1: "幸运招财猫 x1",
    葫芦瓦礼篮x1: "葫芦瓦礼篮 x1",
    手艺花艺x8: "手艺花艺 x8",
    MOLLEorOLDFIELDorREDLEAForTOBISSorMERLOTREDWINE375MLx1:
      "MOLLE / OLD FIELD / REDLEAF / TOBISS / MERLOT RED WINE 375ML X1",
    万事如意: "万事如意",
    野生茶花冬菇150克x1: "野生茶花冬菇150克 x1",
    可喜冰糖燕窝or可喜鸡精70MLx3: "可喜冰糖燕窝/可喜鸡精 70ML X3",
    可喜冰糖燕窝or可喜鸡精70MLx6: "可喜冰糖燕窝/可喜鸡精 70ML X6",
    可喜冰糖燕窝or可喜鸡精70MLx12: "可喜冰糖燕窝/可喜鸡精 70ML x12",
    韩国人参糖x1: "韩国人参糖 X1",
    野生发菜x1: "野生发菜 x1",
    野生发菜30克x1: "野生发菜30克 X1",
    野生发菜30克x2: "野生发菜30克 X2",
    HOOHEE糖果礼盒x1: "HOOHEE糖果礼盒 X1",
    HOOHEE糖果礼盒x2: "HOOHEE糖果礼盒 X2",
    可喜春节礼篮x1: "可喜春节礼篮 X1",
    可喜春节礼篮x2: "可喜春节礼篮 X2",
    年年有余: "年年有余",
    母树大红袍9包装x1: "母树大红袍9包装 X1",
    母树大红袍9包装x2: "母树大红袍9包装 X2",
    北冬蟲夏草or灵芝or人参峰王液体10支装100MLx1:
      "北冬蟲夏草/灵芝/人参峰王液体 10支装 100ML X1",
    北冬蟲夏草or灵芝or人参峰王液体10支装100MLx2:
      "北冬蟲夏草/灵芝/人参峰王液体 10支装 100ML X2",
    顶级虫草花60克x1: "顶级虫草花 60克 X1",
    顶级虫草花60克x2: "顶级虫草花 60克 X2",
    纯正银雪耳150克x1: "纯正银雪耳 150克 X1",
    新年摆饰品x3: "新年摆饰品 x3",
    新年摆饰品x5: "新年摆饰品 X5",
    新年摆饰品x6: "新年摆饰品 X6",
    新年摆饰品x8: "新年摆饰品 x8",
    纳福亨通: "纳福亨通",
    生意兴隆: "生意兴隆",
    福泰安康1个价钱2个礼篮: "福泰安康(1个价钱2个礼篮)",
    迎春纳福: "迎春纳福",
    财源亨通: "财源亨通",
    八仙报喜: "八仙报喜",
    五福临门: "五福临门",
    金玉满堂: "金玉满堂",
    喜气洋洋: "喜气洋洋",
    大吉大利: "大吉大利",
    喜气盈门: "喜气盈门",
    心想事成: "心想事成",
    八方来财: "八方来财",
    千事吉祥: "千事吉祥",
    百事亨通Limited400setonly: "百事亨通*Limited 400 set only",
    合家平安: "合家平安",
    福寿双全: "福寿双全",
    六六大顺: "六六大顺",
    七星高照: "七星高照",
    多福多寿: "多福多寿",
    得心应手: "得心应手",
    四季平安: "四季平安",
    花开富贵: "花开富贵",
    福气东来LIMITED200SET: "福气东来*LIMITED 200 SET",
    福禄寿禧LIMITED200SET: "福禄寿禧*LIMITED 200 SET",
    飞黄腾达LIMITED200SET: "飞黄腾达 LIMITED 200 SET",
    三羊开泰: "三羊开泰",
    祥瑞新年: "祥瑞新年",
    马到成功: "马到成功",
    旗开得胜: "旗开得胜",
    蛇来运转: "蛇来运转",
    喜蛇临门: "喜蛇临门",
    大西洋冰岛鱼胶x1: "大西洋冰岛鱼胶 x1",
    老班章普洱茶饼x1: "老班章普洱茶饼 x1",
    纯天然黑木耳50克x1: "纯天然黑木耳 50克 x1",
    纯天然黑木耳50克x2: "纯天然黑木耳 50克 x2",
    野米花胶or小米花胶or大西洋冰岛鱼就胶240克x1:
      "野米花胶/小米花胶/ 大西洋冰岛鱼就胶 240克 X1",
    野米花胶or小米花胶or大西洋冰岛鱼就胶or佛跳墙240克x1:
      "野米花胶/小米花胶/大西洋冰岛鱼胶/佛跳墙 240克 x1",
    JOHNNIEWALKERBLACKLABELSHERRYCASK700MLx1:
      "JOHNNIE WALKER BLACK LABEL SHERRY CASK 700ML X1",
    传统工艺紫茶壶x1: "传统工艺紫茶壶 x1",
    可喜春节摆饰品: "可喜春节摆饰品",
    可喜春节摆饰品x1: "可喜春节摆饰品 x1",
    可喜春节摆饰品x3: "可喜春节摆饰品 x3",
    可喜春节摆饰品x5: "可喜春节摆饰品 x5",
    可喜春节摆饰品x10: "可喜春节摆饰品 x10",
    可喜春节摆饰品x12: "可喜春节摆饰品 x12",
    可喜礼篮x1: "可喜礼篮 x1",
    林下山参x1: "林下山参 x1条",
    花燕2片装x1: "花燕2片装 x1",
    花燕片3片装x1: "花燕片3片装 x1",
    花燕片3片装x2: "花燕片3片装 x2",
    易武云南普洱大圆茶饼x1: "易武云南普洱大圆茶饼 x1",
    易武云南普洱大圆茶饼加木盒x1: "易武云南普洱大圆茶饼+木盒 x1",
    红参片or鱼胶or人参片or鱼翅礼盒x1: "红参片/鱼胶/人参片/鱼翅礼盒 x1",
    红参片or鱼胶or人参片or鱼翅礼盒x2: "红参片/鱼胶/人参片/鱼翅礼盒 x2",
    红参片or鱼胶or人参片or鱼翅礼盒x3: "红参片/鱼胶/人参片/鱼翅礼盒 x3",
    纽西兰鳕鱼胶x1: "纽西兰鳕鱼胶 x1",
    可喜人参鸡精70mlx6: "可喜人参鸡精 70ml x6",
    燕窝饮料150mlx1: "燕窝饮料 150ml x1",
    燕窝饮料150mlx2: "燕窝饮料 150ml x2",
    燕窝饮料150mlx4: "燕窝饮料 150ml x4",
    燕窝饮料250mlx1: "燕窝饮料 250ml x1",
    燕窝饮料250mlx2: "燕窝饮料 250ml x2",
    燕窝饮料250mlx4: "燕窝饮料 250ml x4",
    贵州茅台王子白酒53巴仙500MLx1: "贵州茅台王子白酒 53% 500ML x1",
    老山参礼盒x1: "老山参礼盒 x1",
    可喜礼蓝x1: "可喜礼蓝 x1",
    可喜摇头舞狮摆件x1: "可喜摇头舞狮摆件 x1",
    日本干贝礼盒SA16粒: "日本干贝礼盒(SA 16粒)",
    金鼠摆件x2: "金鼠摆件 x2",
    冰糖燕窝150MLx3: "冰糖燕窝 150ML x3",
    冰糖燕窝250MLx1: "冰糖燕窝 250ML x1",
    精美可喜礼盒x1: "精美可喜礼盒 x1",
    精美小铁罐x1: "精美小铁罐 x1",
    紫茶壶x1: "紫茶壶 x1",
    清汤一头鲍鱼x2: "清汤一头鲍鱼 x2",
    燕窝黄燕盏120Gx1: "燕窝。 黄燕盏 120G X1",
    海参礼盒x1: "海参礼盒 x1",
    燕窝黄燕盏6片装: "燕窝。黄燕盏 6片装",
    燕窝黄燕盏6片装x1: "燕窝。黄燕盏 6片装 x1",
    醒狮x1: "醒狮 x1",
    招财猫x1: "招财猫 x1",
    南非清汤鲍鱼一头鲍x1: "南非清汤鲍鱼一头鲍 x1",
    海参礼盒装x1: "海参礼盒装 x1",
    红烧海参x1: "红烧海参 x1",
    燕窝2片x1: "燕窝2片 x1",
    冰糖雪蛤240克x1: "冰糖雪蛤 240克 x1",
    佛跳墙x1: "佛跳墙 x1",
    可喜精美扇子礼盒: "可喜精美扇子礼盒",
    精美可喜抽屉礼盒x1: "精美可喜抽屉礼盒 x1",
    可喜红烧海参x1: "可喜红烧海参 x1",
    精美可喜3D礼盒x1: "精美可喜3D礼盒 x1",
    可喜精美礼盒x1: "可喜精美礼盒 x1",
    大红大紫: "大红大紫",
    可喜药材鸡精70MLx6: "可喜药材鸡精 70ML X6",
    冰岛鱼胶x1: "冰岛鱼胶 x1",
    北夏草液体x1: "北夏草液体 x1",
    山珍海味x1: "山珍海味 x1",
    万事逐心: "万事逐心",
    纯天然茶花菇x1: "纯天然茶花菇 x1",
    精品鱼胶x1: "精品鱼胶 x1",
    大红袍x1: "大红袍 x1",
    人参糖x1: "人参糖 x1",
    干贝鲍鱼x1: "干贝鲍鱼 x1",
    百业兴旺: "百业兴旺",
    吉庆有余: "吉庆有余",
    OWLCITYx1: "OWL CITY x1",
    烧好肉碎: "烧好肉碎",
    烧好肉碎500gx1L: "烧好肉碎500g x1",
    烧好鸡肉: "烧好鸡肉",
    烧好鸡肉500gx1: "烧好鸡肉500g x1",
    烧好切片: "烧好切片",
    烧好切片500gx1: "烧好切片500g x1",
    猪肉丝: "猪肉丝",
    猪肉丝300gx1: "猪肉丝300g x1",
    鸡肉丝: "鸡肉丝",
    鸡肉丝300gx1: "鸡肉丝300gx1",
    烧好金钱肉干: "烧好金钱肉干",
    烧好金钱肉干500gx1: "烧好金钱肉干500g x1",
    小鲜炖10bottle50ml: "小鲜炖 10 bottle 50ml",
    小鲜炖50mlx10: "小鲜炖 50ml x10",
    鲜炖纯燕窝品质保证送礼佳品: "鲜炖纯燕窝,品质保证,送礼佳品",
    小鲜炖6bottle70ml: "小鲜炖 6 bottle 70ml",
    小鲜炖70mlx6: "小鲜炖 70ml x6",
    可喜烤肉干礼盒传递健康与美味的最佳选择:
      " 可喜烤肉干礼盒 - 传递健康与美味的最佳选择！",
    普洱茶饼or精美茶壶茶香与烤肉的完美搭配:
      "普洱茶饼/精美茶壶 - 茶香与烤肉的完美搭配！",
    肉干组合肉碎肉干or麻辣肉干or黑胡椒肉干or多种口味满足你的味蕾:
      "肉干组合：肉碎肉干、麻辣肉干、黑胡椒肉干，多种口味满足你的味蕾！",
    本地猪肉and品质看得见and安全又放心:
      "- 100% 本地猪肉，品质看得见，安全又放心！",
    不含任何防腐剂and吃得更健康: "- 不含任何防腐剂，吃得更健康！",
    传统工艺制作and每一片都蕴含匠心: "- 传统工艺制作，每一片都蕴含匠心！",
    切肉片肉干厚实鲜嫩一口满满幸福感: "切肉片肉干：厚实鲜嫩，一口满满幸福感！",
    可喜烤肉干礼盒: "可喜烤肉干礼盒",
    清汤鲍鱼85克5头to6头x1: "清汤鲍鱼 85克 5-6头 x1",
    牌九x1: "牌九 x1",
    MOLLEorOLDFIELDorREDLEAForTOBISSMERLOTREDWINE375MLx1:
      "MOLLE/OLD FIELD/RED LEAF/TOBISS /MERLOT RED WINE 375ML x1",
  },
  [LOCALES.MALAY]: {},
  [LOCALES.INDO]: {},
};
